import { indexedDbStorage } from '@/lib/storage/indexedDbStorage'
import { UnifiedWorkflowState } from './workflowStateTypes'

/**
 * Workflow state storage wrapper using consolidated IndexedDB storage
 * Maintains backward compatibility with existing API
 */
class WorkflowStateStorage {
  async saveState(key: string, state: UnifiedWorkflowState): Promise<void> {
    return indexedDbStorage.saveWorkflowState(key, state)
  }

  async loadState(key: string): Promise<UnifiedWorkflowState | null> {
    return indexedDbStorage.loadWorkflowState(key)
  }

  async deleteState(key: string): Promise<void> {
    return indexedDbStorage.deleteWorkflowState(key)
  }

  async cleanupOldStates(currentKey: string, keepCount: number = 5): Promise<void> {
    return indexedDbStorage.cleanupOldWorkflowStates(currentKey, keepCount)
  }

  async getAllKeys(): Promise<string[]> {
    return indexedDbStorage.getAllWorkflowKeys()
  }
}

export const workflowStateStorage = new WorkflowStateStorage()
